import React from 'react';
import he from 'he';
import PropTypes from 'prop-types';
import DesignComponent from "./DesignComponent";

export default class AttorneyList extends DesignComponent {
    constructor(props) {
        super(props);

        this.handleAttorney = this.handleAttorney.bind(this);
    }

    handleAttorney($attorney, $event) {
        if($event.target.nodeName.toLowerCase() === "a" && $event.target.href.toLowerCase().search("mailto://") > -1) {
            return;
        }
        
        const {
            props: {
                selectAttorney: $selectAttorney,
            }
        } = this;

        $selectAttorney($attorney);
    }

    render() {
        const {
            props: {
                dataKey: $dataKey,
                className: $className,
                attorneys: $attorneys,
                messageNotFound: $messageNotFound,
                activeAttorney: $activeAttorney,
            }, refSectionList: $refSectionList
        } = this;

        return <table cellspacing="0" cellpadding="0" id="attorney-list" className={`${$className}`} key={`${$dataKey ?? ''}-attorney`} ref={$refSectionList}>
            <tbody>
            {$attorneys && $attorneys.length < 1 && <tr><td>{$messageNotFound}</td></tr>}
            {$attorneys && $attorneys.map($a => <tr
                className={($activeAttorney && $activeAttorney === $a) ? "active" : ""}
                onClick={($event) => this.handleAttorney($a, $event)}>
                <td width={80}>
                    <img src={$a.image} width={50} height={50}/>
                </td>
                <td>{he.decode($a.title)}</td>
                <td dangerouslySetInnerHTML={{__html: !!($a.jobTitle)?$a.jobTitle:''}}/>
                <td>{$a.locations && $a.locations.join(' / ')}</td>
                <td>{$a.phoneNumber}</td>
                <td><a href={`mailto://${$a.email}`}>Email {he.decode($a.firstname)}</a></td>
            </tr>)}
            </tbody>
        </table>;
    }
}

AttorneyList.propTypes = {
    dataKey: PropTypes.string,
    attorneys: PropTypes.array.isRequired,
    className: PropTypes.string,
    messageNotFound: PropTypes.string,
    selectAttorney: PropTypes.func,
    activeAttorney: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
}

AttorneyList.defaultProps = {
    dataKey: '',
    attorneys: [],
    className: '',
    messageNotFound: '',
    selectAttorney: () => {
    },
    activeAttorney: false
}